import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";
import { useRef } from "react";

export function useSecurityLevelControls() {
  let L1 = [];
  let L2 = [];
  let L3 = [];

  const selectedLanguage = useSelector(currentSelectedLanguage);
  // const settings = useSelector((state) => state.settings);
  // const defaultSetting = useSelector((state) => state.settings.defaultSetting);
  const tabMap = {
    'Personal': 'personalTab',
    'Company': 'companyTab',
    'Admin': 'AdminTab'
  };

  
  const lookupData = useSelector((state) => state.settings.lookupData);

  function getSecurityLevelControlData(settings,defaultSetting) {

    const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
    let getDefaultSetting = {};

    const createSettingControlObject = (id, type, label, level, controlType = "Radio", options = [], placeholder = "", showTooltip, tooltip) => {
      let setting = level.find((setting) => setting.type.trim() === type.trim());

      let value = setting?.keyValue || "";
      if (type === "MaxReadsPerReader" || type === "MaxViewsPerDocument") {
        value = value === "0" ? "" : value;
      }

      return {
        id: String(id),
        label: selectedLanguage.LstLanguageCodes[`UI_${label}`],
        controlType,
        containerClassname: "mb-3 row align-items-center mx-1",
        value: value,
        isShowLockIconOnDisable: setting?.isLock === "false" || setting?.isLock === "" ? false : true,
        settingType: type,
        level: level === 'common' ? 'common' : level === L1 ? 'l1' : level === L2 ? 'l2' : 'l3',
        options: options,
        Override: setting?.isOverride || "",
        Lock: setting?.isLock || "",
        settingId: getDefaultSetting?.id,
        placeholder: placeholder,
        configLevel: getDefaultSetting?.configLevel,
        isShowToolTip: showTooltip,
        tooltip: tooltip,
        showHistory: true,
        ...(type === "ShareVotes" && level !== "L1" && {
          disableSharevotes: (level?.find((c) => c.type === "Voting" && c.keyValue === "false")) ? true : false,
        })
      };
    };
    if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
      getDefaultSetting = settings[tabKey]?.settingsData?.find(s => s.settingFor === defaultSetting) || {};
      L1 = [...getDefaultSetting?.l1 || []];
      L2 = [...getDefaultSetting?.l2 || []];
      L3 = [...getDefaultSetting?.l3 || []];
    }






    const Level1 = [
      createSettingControlObject("1", "SideNote", "SideNote", L1, "Text Area"),
      createSettingControlObject("2", "AllowResponsesTo", "AllowResponsesTo", L1),
      createSettingControlObject("3", "ProofOfSending", "ProofOfSending", L1),
      createSettingControlObject("5", "Launches", "Launches", L1, "Dropdown", lookupData.launchesOptions, "", true, selectedLanguage.LstLanguageCodes.UI_LaunchesInfo),
      createSettingControlObject("6", "Expires", "Expires", L1, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Expirydays, true, selectedLanguage.LstLanguageCodes.UI_ExpiresInfo),
      createSettingControlObject("7", "Watermark", "Watermark", L1, "Dropdown", lookupData.watermarkOptions),
      createSettingControlObject("8", "MaxViewsPerDocument", "MaxviewsPerDocument", L1, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("9", "Timestamp", "TimeStamp", L1),
      createSettingControlObject("10", "CanPrint", "CanPrint", L1),
      //createSettingControlObject("11", "MaxPrintsPerReader", "MaxPrintsPerReader", L1, "Textbox",[], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("11", "MaxPrintsPerDocument", "MaxPrintsPerDocument", L1, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("12", "AllowedIP", "AllowedIP", L1, "custom-Textbox"),
      createSettingControlObject("13", "BannedRegions", "BannedRegions", L1, "custom-Dropdown", lookupData.bannedRegionOptions),
      createSettingControlObject("14", "TrackKilledDocuments", "TrackKilledDocuments", L1),
      createSettingControlObject("15", "EDisclosure", "EDisclosure", L1),
    ];


    const Level2 = [
      createSettingControlObject("1", "SideNote", "SideNote", L2, "Text Area"),
      createSettingControlObject("2", "AllowResponsesTo", "AllowResponsesTo", L2),
      createSettingControlObject("4", "ProofOfSending", "ProofOfSending", L2),
      createSettingControlObject("5", "DisplayDistributionList", "DisplayDistributionlist", L2),
      createSettingControlObject("6", "Voting", "Voting", L2),
      createSettingControlObject("7", "ShareVotes", "ShareVotes", L2),
      createSettingControlObject("9", "NotificationOfReading", "NotificationofReading", L2),
      createSettingControlObject("10", "Launches", "Launches", L2, "Dropdown", lookupData.launchesOptions, "", true, selectedLanguage.LstLanguageCodes.UI_LaunchesInfo),
      createSettingControlObject("11", "Expires", "Expires", L2, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Expirydays, true, selectedLanguage.LstLanguageCodes.UI_ExpiresInfo),
      createSettingControlObject("12", "RestrictToDomains", "RestrictToDomains", L2, "Textbox", [], selectedLanguage.LstLanguageCodes
        .UI_ExampleORGExample),
      createSettingControlObject("13", "Watermark", "Watermark", L2, "Dropdown", lookupData.watermarkOptions),
      createSettingControlObject("14", "MaxReadsPerReader", "MaxReadsperReader", L2, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("15", "MaxViewsPerDocument", "MaxviewsPerDocument", L2, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      //createSettingControlObject("16", "IdentifyLeakers", "IdentifyLeakers", L2),
      createSettingControlObject("17", "Timestamp", "TimeStamp", L2),
      createSettingControlObject("18", "CanPrint", "CanPrint", L2),
      createSettingControlObject("19", "MaxPrintsPerReader", "MaxPrintsPerReader", L2, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("20", "MaxPrintsPerDocument", "MaxPrintsPerDocument", L2, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("21", "AllowedIP", "AllowedIP", L2, "custom-Textbox"),
      createSettingControlObject("22", "BannedRegions", "BannedRegions", L2, "custom-Dropdown", lookupData.bannedRegionOptions),
      createSettingControlObject("23", "TrackKilledDocuments", "TrackKilledDocuments", L2),
      createSettingControlObject("24", "SMSAuthentication", "SMSAuthentication", L2),
      createSettingControlObject("25", "EDisclosure", "EDisclosure", L2),
    ];


    const Level3 = [
      createSettingControlObject("1", "SideNote", "SideNote", L3, "Text Area"),
      createSettingControlObject("2", "AllowResponsesTo", "AllowResponsesTo", L3),
      createSettingControlObject("4", "ProofOfSending", "ProofOfSending", L3),
      createSettingControlObject("5", "DisplayDistributionList", "DisplayDistributionlist", L3),
      createSettingControlObject("6", "Voting", "Voting", L3),
      createSettingControlObject("7", "ShareVotes", "ShareVotes", L3),
      createSettingControlObject("9", "NotificationOfReading", "NotificationofReading", L3),
      createSettingControlObject("10", "Launches", "Launches", L3, "Dropdown", lookupData.launchesOptions, "", true, selectedLanguage.LstLanguageCodes.UI_LaunchesInfo),
      createSettingControlObject("11", "Expires", "Expires", L3, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Expirydays, true, selectedLanguage.LstLanguageCodes.UI_ExpiresInfo),
      createSettingControlObject("12", "RestrictToDomains", "RestrictToDomains", L3, "Textbox", [], selectedLanguage.LstLanguageCodes
        .UI_ExampleORGExample),
      createSettingControlObject("13", "Watermark", "Watermark", L3, "Dropdown", lookupData.watermarkOptions),
      createSettingControlObject("14", "MaxReadsPerReader", "MaxReadsperReader", L3, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("15", "MaxViewsPerDocument", "MaxviewsPerDocument", L3, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      //createSettingControlObject("16", "IdentifyLeakers", "IdentifyLeakers", L3),
      createSettingControlObject("17", "Timestamp", "TimeStamp", L3),
      createSettingControlObject("18", "CanPrint", "CanPrint", L3),
      createSettingControlObject("19", "MaxPrintsPerReader", "MaxPrintsPerReader", L3, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("20", "MaxPrintsPerDocument", "MaxPrintsPerDocument", L3, "Textbox", [], selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("21", "AllowedIP", "AllowedIP", L3, "custom-Textbox"),
      createSettingControlObject("22", "BannedRegions", "BannedRegions", L3, "custom-Dropdown", lookupData.bannedRegionOptions),
      createSettingControlObject("23", "TrackKilledDocuments", "TrackKilledDocuments", L3),
      createSettingControlObject("24", "SMSAuthentication", "SMSAuthentication", L3),
      createSettingControlObject("25", "EDisclosure", "EDisclosure", L3),
    ];
    return [Level1, Level2, Level3];
  }

  return {
    getSecurityLevelControlData
  }

}
